import { HTTPStatuses, type HttpError } from '@packages/domain/constants/http';
import { isHttpErrorWithStatus } from '@packages/domain/utils/errors/errors';
import {
  FETCH_ORDER_FAILURE,
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
} from 'constants/orders';
import type { Order } from 'models/order';
import { getOrder } from 'selectors/entities/order/order';
import { isFetching } from 'selectors/ui/ui';
import type { PayexThunkAction } from 'store/configureStore';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';

type FetchOrderParameters = {
  orderId: string;
  token: string;
};

export const fetchOrder =
  ({
    orderId,
    token,
  }: FetchOrderParameters): PayexThunkAction<
    Promise<void | Order | { type: string; payload: Order }>
  > =>
  async (dispatch, getState, { apiV3 }) => {
    const state = getState();

    const order = getOrder(state);
    if (order && order.id) {
      return Promise.resolve(order);
    }

    const isFetchingOrder = isFetching(state, 'order');
    if (isFetchingOrder) {
      return Promise.resolve();
    }

    dispatch({ type: FETCH_ORDER_REQUEST });

    return apiV3.orders
      .fetch({ orderId, token })
      .then(response =>
        dispatch({ type: FETCH_ORDER_SUCCESS, payload: response as Order }),
      )
      .catch((error: Error) => {
        if (isHttpErrorWithStatus(error)) {
          const { status = '' } = error as HttpError;

          dispatch({ type: FETCH_ORDER_FAILURE });

          if (status !== HTTPStatuses.NOT_FOUND) {
            error.message = `${FETCH_ORDER_FAILURE} ${error.message}`;
            errorNotifier.notifyWithFingerprint(error, [
              FETCH_ORDER_FAILURE,
              `${status}`,
            ]);
          }
        }
      });
  };
